import { RiPulseLine } from '@remixicon/react';
import {
  createFrontendPlugin,
  PageBlueprint,
  PluginHeaderActionBlueprint,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import type { OverridableFrontendPlugin } from '@backstage/frontend-plugin-api';
import { entityCardChecks } from './components/entity-card-checks';
import { entityContentPulse } from './components/entity-content';
import { entityContentPulseInsights } from './components/group-insights-content';
import {
  checksRouteRef,
  insightsRouteRef,
  integrationsRouteRef,
  rootRouteRef,
  tracksRouteRef,
} from './routes';
import { entityCardPulse } from './components/entity-card-pulse';
// Eager imports so navigating between Pulse sub-pages doesn't trigger a
// per-chunk Suspense fallback (progress bar); each page shows its own skeleton.
import { PulseTracksRouting } from './components/tracks';
import { PulseChecksRouting } from './components/checks';
import { PulseInsightsPage } from './components/insights';
import { PulseIntegrationsRouting } from './components/integrations';

export const page = PageBlueprint.make({
  params: {
    path: '/pulse',
    routeRef: rootRouteRef,
    title: 'Pulse',
    icon: <RiPulseLine />,
  },
});

export const headerActions = PluginHeaderActionBlueprint.make({
  params: defineParams =>
    defineParams({
      loader: () =>
        import('./components/header-actions').then(m => <m.HeaderActions />),
    }),
});

const integrationsSubPage = SubPageBlueprint.make({
  name: 'integrations',
  params: {
    path: 'integrations',
    title: 'Integrations',
    routeRef: integrationsRouteRef,
    loader: () => Promise.resolve(<PulseIntegrationsRouting />),
  },
});

const insightsSubPage = SubPageBlueprint.make({
  name: 'insights',
  params: {
    path: 'insights',
    title: 'Insights',
    routeRef: insightsRouteRef,
    loader: () => Promise.resolve(<PulseInsightsPage />),
  },
});

const checksSubPage = SubPageBlueprint.make({
  name: 'checks',
  params: {
    path: 'checks',
    title: 'Checks',
    routeRef: checksRouteRef,
    loader: () => Promise.resolve(<PulseChecksRouting />),
  },
});

const tracksSubPage = SubPageBlueprint.make({
  name: 'tracks',
  params: {
    path: 'tracks',
    title: 'Tracks',
    routeRef: tracksRouteRef,
    loader: () => Promise.resolve(<PulseTracksRouting />),
  },
});

export const pulsePlugin: OverridableFrontendPlugin<{
  root: typeof rootRouteRef;
}> = createFrontendPlugin({
  pluginId: 'pulse',
  extensions: [
    page,
    headerActions,
    insightsSubPage,
    checksSubPage,
    tracksSubPage,
    integrationsSubPage,
    entityCardPulse,
    entityCardChecks,
    entityContentPulse,
    entityContentPulseInsights,
  ],
  routes: {
    root: rootRouteRef,
  },
});
